import { CreateFileInput } from "../../../Shared/dto/create-file-input";
import { PageOptionsDto } from "../../../Shared/dto/page.options.dto";
import { HttpService } from "../../../Shared/Utils/HttpService";
import { CreateVehicleInput } from "../models/CreateVehicleInput";

export class VehicleService {
  static async create(createVehicleInput: CreateVehicleInput) {
    return await HttpService.request({
      url: "/vehicles/create",
      method: "POST",
      data: createVehicleInput,
      contentType: "json",
    });
  }

  static async createFromFile(createFromFileInput: CreateFileInput) {
    return await HttpService.request({
      url: "/vehicles/create/from-file",
      method: "POST",
      data: createFromFileInput,
    });
  }

  static async getById(id: string) {
    return await HttpService.request({
      url: `/vehicles/find/${id}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async update(id: string, updateVehicleInput: CreateVehicleInput) {
    return await HttpService.request({
      url: `/vehicles/${id}`,
      method: "PUT",
      data: updateVehicleInput,
      contentType: "json",
    });
  }

  static async deleteOne(id: string) {
    return await HttpService.request({
      url: `/vehicles/${id}`,
      method: "DELETE",
      contentType: "json",
    });
  }

  static async delete(ids: string[]) {
    return await HttpService.request({
      url: `/vehicles/${JSON.stringify(ids)}`,
      method: "DELETE",
      contentType: "json",
    });
  }

  static async getAll(pageOptions: PageOptionsDto) {
    const queryParams = new URLSearchParams({
      order: pageOptions.order || "DESC",
      page: pageOptions.page.toString(),
      query: pageOptions.query || "",
      take: pageOptions.take.toString(),
    }).toString();

    return await HttpService.request({
      url: `/vehicles/find?${queryParams}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async findAll(findOptions: Object) {
    const query = encodeURIComponent(JSON.stringify(findOptions));
    return await HttpService.request({
      url: `/vehicles?findOptions=${query}`,
      method: "GET",
      contentType: "json",
    });
  }

  static async search(query: string) {
    return await HttpService.request({
      url: `/vehicles/search?query=${encodeURIComponent(query)}`,
      method: "GET",
      contentType: "json",
    });
  }
}
